import React, { useState } from "react";
import jsDig from "utils/jsDig";
import LiteMetricTable from "dashboards/lite/LiteMetricTable";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import ObjectivePicker from "./ObjectivePicker";
import DashboardOptions from "./DashboardOptions";
import LiteKeywordTable from "dashboards/lite/LiteKeywordTable";
import { capitalize } from "lodash";

export default function OrganicSearchDashboard(props) {
  console.log(props)
  const metricTableDimensions = jsDig(["overall", "total", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "total", "spend"], props.table_data)) : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", "YTD", "Total"];
  // Landing pages have already been sorted so just grab the first 15 for the increase/decrease table dimensions
  const landingPageIncreasesDimensions = jsDig(["overall", "landing_page_increase_l30", "sessions"], props.table_data) ? Object.keys(jsDig(["overall", "landing_page_increase_l30", "sessions"], props.table_data)).slice(0, 15) : [];
  const landingPageDecreasesDimensions = jsDig(["overall", "landing_page_decrease_l30", "sessions"], props.table_data) ? Object.keys(jsDig(["overall", "landing_page_decrease_l30", "sessions"], props.table_data)).slice(0, 15) : [];
  // Convert utc date to local time in this format 12:30 PM, 12/31/2021
  const lastDataPull = new Date(jsDig(["last_data_pull"], props)).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });

  const thisYear = new Date().getFullYear();
  const lastYear = thisYear - 1;

  let mainIcon = require("images/lite/icons/search.svg");
  mainIcon = <div className="organic-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>

  const [dashboardObjective, setDashboardObjective] = useState(props.client_account.dashboard_objective ? props.client_account.dashboard_objective : "sales");
  let revenueOrConversions = dashboardObjective == "sales" ? "revenue" : "conversions";
  let roasOrCpa = dashboardObjective == "sales" ? "roas" : "cpa";

  const dashboardType = "organic_search"
  const [dashboardOptions, setDashboardOptions] = useState(props.client_account.dashboard_options ? props.client_account.dashboard_options : {});

  return (
    <>
      <div className="lite-dashboard overview-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>Organic Search Dashboard</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
          <div className="dashboard-header-right flex-end">
            <div className="most-recent-refresh">
              <small id="most-recent-refresh">Last refresh: {props.last_data_pull ? lastDataPull : "Never"}</small>
            </div>
            <div className="objective-refresh-container">
              <ObjectivePicker setDashboardObjective={setDashboardObjective} dashboardObjective={dashboardObjective} />
              {props.user_is_employee && (
                <LiteRefresh refreshPreference={props.default_refresh_preference} currentDashboard={"organic_search"} accountId={props.client_account.id} alreadyPulling={props.current_data_pulls} />
              )}
              <DashboardOptions dashboardOptions={dashboardOptions} setDashboardOptions={setDashboardOptions} dashboardType={dashboardType} accountId={props.client_account.id} />
            </div>
          </div>
        </div>

        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <h3>Organic Traffic L60D</h3>
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "sessions", "data"], props.chart_data)}
                metric="sessions"
              />
            </div>
            <div className="lite-metric-chart">
              <h3>Organic {capitalize(revenueOrConversions)} L60D</h3>
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", revenueOrConversions, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", revenueOrConversions, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", revenueOrConversions, "data"], props.chart_data)}
                metric={revenueOrConversions}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["sessions", revenueOrConversions]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={
                  {
                    "total": jsDig(["overall", "total"], props.table_data),
                    "shopping": jsDig(["overall", "shopping"], props.table_data),
                  }
                }
                tableName="TOTAL ORGANIC SEARCH"
                dimensions={metricTableDimensions}
                groups={["Total", "Shopping"]}
              />
            </div>
            <div className="lite-metric-chart">
              <h3>Organic Shopping Traffic L60D</h3>
              <LiteLineChart 
                datasetNames={jsDig(["overall", "shopping", "sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "shopping", "sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "shopping", "sessions", "data"], props.chart_data)}
                metric="sessions"
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["sessions", revenueOrConversions]}
                subHeaderOrder={[lastYear, thisYear, "Diff", "Y/Y"]}
                data={jsDig(["overall", "landing_page_increase_l30"], props.table_data)}
                tableName="TOP LANDING PAGE INCREASES L30D"
                dimensions={landingPageIncreasesDimensions}
                containsUrl={true}
                baseUrl={props.client_account.website}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["sessions", revenueOrConversions]}
                subHeaderOrder={[lastYear, thisYear, "Diff", "Y/Y"]}
                data={jsDig(["overall", "landing_page_decrease_l30"], props.table_data)}
                tableName="TOP LANDING PAGE DECREASES L30D"
                dimensions={landingPageDecreasesDimensions}
                containsUrl={true}
                baseUrl={props.client_account.website}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteKeywordTable
                keywords={jsDig(["keyword_rankings"], props)}
                metrics={["keywordName", "keywordPreviousPosition", "keywordCurrentPosition", "keywordSearchVolume", "keywordUrl", "keywordDifference"]}
                keyword_sort_order_asc={true}
                keyword_sort={"currentpos"}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["sessions", revenueOrConversions]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={
                  {
                    "total": jsDig(["overall", "l60", "total"], props.table_data),
                    "shopping": jsDig(["overall", "l60", "shopping"], props.table_data),
                  }
                }
                tableName="TOTAL ORGANIC - DAILY L60D"
                dimensions={jsDig(["overall", "l60", "total", "sessions"], props.table_data) ? Object.keys(jsDig(["overall", "l60", "total", "sessions"], props.table_data)) : []}
                topSummaryRow={{dimension: "L7D >", data: jsDig(["overall", "l7"], props.table_data)}}
                collapsed={true}
                groups={["Total", "Shopping"]}
              />
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
